import { YOUR_FINANCE_BLADE_ID } from '../../types';
import YourFinance from '../yourFinance/YourFinance';
import { YourFinanceBladeProps } from '../yourFinance/yourFinanceTypes';

const BorrowingInput = ({ isFocusedBlade }: YourFinanceBladeProps) => (
    <YourFinance
        isFocusedBlade={isFocusedBlade}
        bladeId={YOUR_FINANCE_BLADE_ID.BORROWING_INPUT}
        isFrequencyDrowdownAscent
        isCollapseDebt
    />
);

export default BorrowingInput;
